import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * DroppableAttribute component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    signalTop: {
      display: 'flex',
      width: '100%',
    },
    treatmentTop: {
      display: 'flex',
      width: '100%',
    },
    label: {
      '&&': {
        color: variables.color.primary.mediumGray,
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '1.4rem',
        marginBottom: '0.4rem',
        '&[data-invalid="true"]': {
          color: variables.color.semantic.negative,
        },
      },
    },
    signalBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '21.6rem',
      maxWidth: `calc(100% / 4 - ${theme.spacing(1)}px)`,
      flexShrink: 0,
      marginRight: theme.spacing(1),
    },
    treatmentBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '21.6rem',
      maxWidth: `200px`,
      flexShrink: 0,
      marginRight: theme.spacing(1),
    },
    signalFieldContainer: {
      maxHeight: '6.5rem',
    },
    placeholder: {
      color: variables.color.primary.halfMediumGray,
      '&[data-invalid="true"]': {
        color: variables.color.semantic.negative,
      },
    },
    signalField: {
      alignItems: 'center',
      background: variables.color.primary.white,
      border: `${variables.borderWidth.sm} solid ${variables.color.primary.lightGrayDarker}`,
      borderRadius: '0.8rem',
      display: 'flex',
      height: '3.2rem',
      padding: theme.spacing(1, 1.5),

      '&[data-invalid="true"]': {
        background: variables.color.semantic.backgroundNegative,
        border: `${variables.borderWidth.sm} solid ${variables.color.semantic.negative}`,
        color: variables.color.semantic.negative,
      },
    },

    signalFieldDraggingOver: {
      backgroundColor: 'rgba(2, 80, 217, .2)',
      borderColor: '#0250d9',
      borderStyle: 'dashed',
    },
  }),
);
